import { Briefcase } from 'lucide-react';
import type { OnboardingIconProps } from './OnboardingIconProps';

const PREMIUM_STROKE = {
  strokeWidth: 1.25,
  absoluteStrokeWidth: true,
} as const;

/** Premium briefcase (Lucide, tuned for onboarding glass rings) */
export function LawyerRoleIcon({ className, ...props }: OnboardingIconProps) {
  return (
    <Briefcase
      className={className}
      aria-hidden
      {...PREMIUM_STROKE}
      {...props}
    />
  );
}
